<template>
  <transition name="fade">
    <div
      class="modal"
      v-if="isShowInsertAudio"
      style="z-index:1000;"
    >
      <div class="container">
        <div class="upload_top msp_icon_close">
          <span style="float:left;">素材库音频</span>
          <span
            class="iconfont el-icon-close"
            style="float:right;font-size:20px;cursor:pointer;line-height:44px;"
            @click.stop='closeInsertAudioBox()'
          ></span>
        </div>
        <div class="insert_video">
          <div class="insert_video_repo">
            <repotree
              @folderClick='handleNodeClick'
              :isHidePersonRepo='false'
            ></repotree>
          </div>
          <div
            class="nodata_pic"
            v-show='audioList.length==0'
          >
            <img
              src="../../../static/img/nodata.png"
              alt=""
            />
            <div>空空如也。。。</div>
          </div>
          <div
            class="insert_video_list"
            v-loading='audioloading'
            element-loading-text="拼命加载中"
          >
            <el-scrollbar
              class="insert_material_video"
              v-show='audioList.length>0'
            >
              <ul class="materialaudio_list">
                <li v-for='item in audioList'>
                  <div
                    class="material_audio_name"
                    style="flex:1;"
                  >
                    <img
                      src="../../../static/img/audio.png"
                      alt=""
                    />
                    <span class="audio_file_name">{{item.file_name}}</span>
                    <div class="operate_audio">
                      <span
                        class="iconfont icon-yulan1"
                        title="预览"
                        @click.stop='previewAudio(item)'
                      ></span>
                      <span
                        class="iconfont icon-charu"
                        title="插入"
                        style="font-size:20px;"
                        @click.stop='insertEditorAudioUrl(item)'
                      ></span>
                    </div>
                  </div>

                </li>
              </ul>

            </el-scrollbar>
          </div>
        </div>
        <div class="page_pagenation">
          <el-pagination
            :current-page.sync="currentPage"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next, jumper"
            :total="audioAllTotal"
          >
          </el-pagination>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import * as api from '../../../api'
import Vue from 'vue'
import repotree from '../repotree/repotree'
export default {
  components: {
    repotree
  },
  mounted () {
    this.$root.eventHub.$on('insertAudioModel', (data) => {
      this.isShowInsertAudio = true
      this.editorIns = data
    })
  },
  destroyed () {
    this.$root.eventHub.$off('insertAudioModel')
  },
  data () {
    return {
      audioList: [],
      currentFolder: '',
      pageSize: 20,
      audioAllTotal: 0,
      currentPage: 1,
      isShowInsertAudio: false,
      audioloading: false,
      editorIns: ''
    }
  },
  methods: {
    closeInsertAudioBox () {
      this.isShowInsertAudio = false
    },
    handleNodeClick (data) {
      this.currentFolder = data
      if (!data.flag_repo) {
        this.currentPage = 1
        this.getAudioList(0, data)
      }
    },
    getAudioList (pagenow, data) {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                       // 必须字段： 参数
          'sortTime': 'time_update', // 排序时间（创建时间：time_create | 更新时间:time_update）
          'sortRule': 'desc', // 排序规则（正序:asc | 倒叙: desc）
          'definition': '', // 清晰度（高清:high|标清:standard）
          'composition': 'all', // 构图（全部:all/横图:heng/竖图:shu/方图:fang）
          'widthAndHigh': 0,
          'width': 0,
          'height': 0,
          'format': '',
          'startSize': '',
          'endSize': '',
          'flag_issue': 'all', // 签发状态 全部：all  已签：yes，未签：no
          'flag_push': 'all', // 推送状态： 全部：all  已推送：yes  未推送：no
          'flag_audit': 'all', // 审核状态： 全部：all  已审核：yes  未审核：no  审核中： doing
          'folderId': data.id,
          'type': 'audio', // 素材类型：图片 picture 视频 video 音频 audio  附件 file
          'tags': [], // 标签
          'searchValue': '',
          'searchType': 'all',
          'pageSize': this.pageSize,
          'pageNum': pagenow,
          'startTime': '',
          'endTime': ''
        }
      }
      this.audioloading = true
      this.currentPage = pagenow + 1
      api._post(_VIDEOAUDIOURL_ + 'public/pageQuery', option).then((res) => {
        if (res.code == 200) {
          try {
            this.audioAllTotal = res.data.totalElements
            this.audioList = res.data.content
          } catch (e) {
            this.audioAllTotal = 0
            this.audioList = []

          }
        } else {
          this.audioAllTotal = 0
          this.audioList = []
        }
        this.audioloading = false
      }).catch((error) => {
        console.log(error)
        this.audioloading = false
      })
    },
    handleCurrentChange (page) {
      if (!(this.currentFolder.flag_repo)) {
        this.getAudioList(page - 1, this.currentFolder)
      }
    },
    insertEditorAudioUrl (item) {
      if (item.id_vod) {
        this.audioloading = true
        var option = {
          ...this.$store.getters.baseOption,
          'params': {
            'id': item.id,
          }
        }
        api._post(_VIDEOAUDIOURL_ + 'av/video/internal_video_url', option).then((resp) => {
          if (resp.code === 200) {
            if (resp.data) {
              this.editorIns.insertMeidaAudio(resp.data.videoUrl)
              this.isShowInsertAudio = false
            }
          }
          this.audioloading = false
        }).catch((error) => {
          console.log(error)
          this.audioloading = false
        })
      } else {
        this.editorIns.insertMeidaAudio(item.url)
        this.isShowInsertAudio = false
      }

    },
    previewAudio (item) {
      this.$root.eventHub.$emit('getMatterDetail', item, 'audioDetail')
    }
  },
  watch: {
    isShowInsertAudio () {
      if (this.isShowInsertAudio == false) {
        this.audioList = []
        this.currentFolder = ''
        this.audioAllTotal = 0
        this.currentPage = 1
      }
    }
  }
}

</script>

<style scoped>
.container {
  transition: all 1s ease;
  width: 60%;
  height: 80%;
  background-color: #ffffff;
  box-shadow: 0px 0px 5px #999;
  border-radius: 5px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
}

.upload_top {
  width: 100%;
  height: 44px;
  line-height: 44px;
  background: #f7faff;
  border-bottom: 1px solid #c0beff;
  clear: both;
  padding: 0 20px 0 20px;
  box-sizing: border-box;
}
.upload_top span {
  color: #333333;
  font-size: 14px;
}
.insert_video {
  width: 100%;
  height: calc(100% - 44px);
  display: flex;
  box-sizing: border-box;
}
.insert_video_repo {
  width: 300px;
  height: 100%;
  box-sizing: border-box;
  border-right: 1px solid #e8e8e8;
}
.insert_video_list {
  flex: 1;
  height: 98%;
  position: relative;
}
.page_pagenation {
  position: absolute;
  bottom: 30px;
  left: 340px;
}
.insert_material_video {
  height: 90%;
}

.nodata_pic {
  position: absolute;
  left: 55%;
  top: 40%;
}
.nodata_pic div {
  color: #333;
  font-size: 20px;
  padding-left: 20px;
  box-sizing: border-box;
}

.materialaudio_list {
  width: 100%;
  padding-left: 10px;
  padding-right: 10px;
  box-sizing: border-box;
}

.materialaudio_list li {
  width: 100%;
  height: 60px;
  display: flex;
  border-bottom: 1px solid #c8c8c8;
  cursor: pointer;
  padding-right: 20px;
  box-sizing: border-box;
}

.material_audio_name {
  height: 60px;
  display: flex;
  clear: both;
  align-items: center;
  position: relative;
}

.material_audio_size {
  justify-content: center;
}
.material_audio_name span {
  color: #333333;
  font-size: 14px;
}
.material_audio_name img {
  display: block;
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

.materialaudio_list li:hover {
  background-color: rgba(246, 250, 255, 1);
}
.materialaudio_list .audio_file_name {
  display: inline-block;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.operate_audio {
  height: 60px;
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
  display: none;
  align-items: center;
}

.operate_audio .iconfont {
  color: #b5b8d9;
  font-size: 18px;
  cursor: pointer;
  margin-left: 20px;
  box-sizing: border-box;
}

.materialaudio_list li:hover .operate_audio {
  display: flex;
}
</style>
